import { Main } from "layouts";
import { MainList } from "components";

import { sort, filters } from "./const/data";

import { ReactComponent as WarehouseIcon } from "icons/warehouse.svg";
import getProductStatus from "utils/getProductStatus";

const EmptyStockPositions = ({
  match: {
    params: { id },
  },
}) => {
  return (
    <Main
      page={{
        name: "Pozycje z produktami z zerowym stanem",
        icon: <WarehouseIcon />,
        breadcrumbs: [
          {
            name: "Zarządzanie magazynem",
            path: "/warehouses",
          },
          { name: "Pozycje z produktami z zerowym stanem" },
        ],
      }}>
      <MainList
        query_key="warehouse_empty_stock_positions"
        api_path="/product_main_locations/empty_stock_positions"
        api_ransack={`warehouse_id=${id}`}
        sort_column="id"
        sort_direction="desc"
        sort={sort}
        filters={filters}
        renderItem={({
          id,
          stock,
          warehouse_position,
          product,
        }) => (
          <>
            <td>{id}</td>
            <td>{warehouse_position?.identifier}</td>
            <td>{product?.sku}</td>
            <td>{product?.name}</td>
            <td>{stock || 0}</td>
            <td>
              <div
                className={`product_status product_status__big ${
                  getProductStatus(product?.status)?.color
                }`}>
                <span>
                  {getProductStatus(product?.status)?.name}
                </span>
              </div>
            </td>
          </>
        )}
        renderActions={({ product }) => [
          {
            type: "edit",
            handleClick: () =>
              window.open(
                `/products/${product?.id}/localization`,
                "_blank"
              ),
          },
        ]}
      />
    </Main>
  );
};

export default EmptyStockPositions;
